import React from "react";

export default function Input({
  handleChange,
  title,
  value,
  name,
  color,
  border,
}) {
  return (
    <label className="sidebar-level-container">
      <input
        onChange={() => handleChange(value, name)}
        type="radio"
        name={name}
        value={value}
        color={color}
      />
      <span
        className={`checkMark ${value === "all" && "all"}`}
        style={{ backgroundColor: color, border: border }}
      ></span>
      {title}
    </label>
  );
}
